/* eslint-disable import/no-unresolved */
import React from 'react';

import telecommunicationSVG from 'assets/resources/pages/software-services/telecommunication_icon.svg';
import otherSVG from 'assets/resources/pages/software-services/other.svg';

import imagesPillarPages from '../components/imagesPillarPages';
import Layout from '../components/Layout';
import PartialsHeader from '../components/Partials/PartialsHeader';
import About from '../components/SoftwareServices/WhatWeDo/About';
import Steps from '../components/SoftwareServices/WhatWeDo/Steps';
import Technologies from '../components/SoftwareServices/WhatWeDo/Technologies';
import MailChimpSmallForm from '../components/MailChimpSmallFrom';
import PartialsQuestion from '../components/Partials/PartialsQuestion';
import SingleBox from '../components/SoftwareServices/WhatWeDo/WhatWeDoPartials/AboutSingleBox';

const SoftwareServices = ({ location }) => {
  const conf = {
    btnText: 'Contact us',
    subtitle: ' '
  };

  return (
    <Layout
      title="Software development services | Ulam Labs"
      description="Web development, frontend and backend development, cryptocurrency and exchange platform - our team can help you create your product. Get all services under one roof!"
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Software Services</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <div className="software-services main-view" id="what-we-do">
        <About />
        <div className="" style={{ background: '#eaebf1' }}>
          <Technologies
            greyBg
            subtitle="Technology we use"
            extraText="Ulam Labs developers are using modern, secure and reliable technologies to turn your ideas into reality. 
          Our experts have years of experience in technologies like Python, Vue, React &amp; Kubernetes"
          />
        </div>
        <div className="container-fluid py-5">
          <div className="container">
            <div className="subtitle without bigger">
              Business-oriented software development
              <div className="extra">
                No matter what industry you operate in, we have the engineers
                and expertise to create any digital product or service to fit
                your business case. We have strong experience in custom software
                development for blockchain, telecommunication, and e-commerce
                projects.
              </div>
            </div>
            <div className="bg-beam">
              <div className="info-box">
                <div className="row">
                  <SingleBox
                    withLongText
                    image={imagesPillarPages.bitcoinPillar}
                    heading="FinTech"
                    details="Jumping into FinTech world without much experience can lead to inefficiencies that will consume your time and budget. Use our expertise to your advantage."
                    link="/software-services/cryptocurrency-trading-platforms/"
                  />
                  <SingleBox
                    withLongText
                    image={telecommunicationSVG}
                    heading="Telecommunications"
                    details="Building cutting-edge telecommunication technology is our bread and butter since we started. We have already paved the way for your idea."
                    link="/industries/telecommunication/"
                  />
                  <SingleBox
                    withLongText
                    image={otherSVG}
                    heading="Other specializations"
                    details="Check other cases in which we have already built products."
                    link="/industries/other/"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="simple-service landing expended main-view text-format custom-banner">
          <div className="container">
            <div className="main-beam">
              <div className="main-banner suspend">
                <div className="left-section">
                  <div className="body">
                    <h2 className="tt">Need to present our offering?</h2>
                    <div className="dd">
                      Here’s our complete company presentation
                    </div>
                  </div>
                </div>
                <div className="small-form right-section">
                  <MailChimpSmallForm
                    tags={['services: presentation']}
                    currentUrl={location.href}
                    dataLayerSource="presentation"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Steps />
        <PartialsQuestion
          title="Have a question concerning bespoke software development?"
          additionalConfig={conf}
        />
      </div>
    </Layout>
  );
};

export default SoftwareServices;
